<template>
  <div
    v-if="getT"
    class="options-container"
    :class="{ collapsed: collapsed }"
  >
    <header
      v-if="showFinishingOptionsHeading"
      class="note-header"
    >
      <h5 v-if="getT">
        {{
          getT.static.customizer[0].options_container[0]
            .finishing_option_list[0].heading
        }}
      </h5>
      <div class="description">
        <button v-on:click="showPopup()" v-if="getT">
          {{
            getT.static.customizer[0].options_container[0]
              .finishing_option_list[0].learn_more_button_text
          }}
        </button>
      </div>
    </header>
    <ul class="option-list">
      <li v-if="currPool.options.skirting">
        <OptionDropdownImage
          optionKey="skirting"
          show="currPool.options.skirting"
          :style="{
            'max-height':
              $store.state.optionSelections.install.value === 'In-Ground' ? 0 : '7em',
          }"
          @clickedToggleOption="logSkirting($event, currPool)"
        />
      </li>
      <li v-if="currPool.options.coping">
        <OptionDropdownImage
          show="currPool.options.coping"
          optionKey="coping"
          @clickedToggleOption="logCoping($event, currPool)"
        />
      </li>
    </ul>
  </div>
</template>
<script>
import OptionDropdownImage from './OptionDropdownImage';
import { mapGetters } from 'vuex';

export default {
  name: 'FinishingOptionList',
  props: ['collapsed'],
  components: {
    OptionDropdownImage,
  },
  computed: {
    ...mapGetters(['getT', 'currPool']),
    showFinishingOptionsHeading() {
      // if selected pool is in modular category
      if (this.$store.getters.categoryTagOfSelectedModel === 'custom') {
        // not for these pools
        if (this.currPool.tag == 'sp105') return false;
        if (this.currPool.tag == 'ep207') return false;
        // any other modular pool, yes
        return true;
      } else {
        // not for Spas
        return false;
      }
    }
  },
  methods: {
    showPopup() {
      this.$store.commit('showFinishingOptionsPopup');
    },
    logSkirting($event, model){
      // track event for Google Analytics
      this.$gtag.event($event + ' Skirting Clicked', {
        'event_category': ' Skirting Option Selection',
        'event_label': $event + ' Skirting Clicked',
        'selected_pool': model.title
      });
    },
    logCoping($event, model){
      // track event for Google Analytics
      this.$gtag.event($event + ' Coping Clicked', {
        'event_category': ' Coping Option Selection',
        'event_label': $event + ' Coping Clicked',
        'selected_pool': model.title
      });
    },
  },
};
</script>
<style scoped lang="scss">
.options-container {
  overflow-y: auto;
  overflow-x: hidden; // iOS - prevent horizontal drag
  ul.option-list {
    margin: 0;
    padding: 0;
    li {
      line-height: 0;
      & > div {
        line-height: normal;
      }
    }
  }
}
</style>
